import React from "react";

const NewUserSplash = () => {
  return (
    <div className="new-user-splash">
      <div className="container new-user-splash__wrapper">
        <div className="new-user-splash__content">
          <h1 className="new-user-splash__title">Let's get enquiring</h1>
          <p className="new-user-splash__copy">
            Once you have some enquiries come back to your inbox to chat and
            create those meaningfull moments in amazing spaces.
          </p>
          <a href="/">
            <button className="button button--dark">Home</button>
          </a>
        </div>
        <img
          className="new-user-splash__image"
          src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/meaningfull_moments/QueenOfHoxton.jpg"
          alt="error image"
        />
      </div>
    </div>
  );
};

export default NewUserSplash;
